var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 8,
    viewBox: "0 0 12 8",
    width: 12,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.11249231 7.76296296c-.06676923 0-.13323077-.02459259-.184-.07348148l-3.85230769-3.70933333c-.10153847-.09807408-.10153847-.25659259 0-.35466667.10184615-.09777778.26676923-.09807407.36830769 0l3.668 3.53214815 7.35661539-7.08414815c.1018461-.09807407.2664615-.09807407.3683077 0 .1015384.09777778.1015384.25659259 0 .35466667l-7.54092309 7.26133333c-.05076923.04888889-.11723077.07348148-.184.07348148",
    fill: "#27880e",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.f94614950a76001b93d5078e2e3d6dd0.svg";
export { ForwardRef as ReactComponent };